import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { ProtectedRoute } from './components/protectedRoute';
import AuthProvider from './hooks/AuthProvider';
import Feedbacks from './pages/Feedbacks';
import Home from './pages/Home';
import Login from './pages/Login';
// import Request from './pages/Request';
export default function App(props) {

  useEffect(() => {
    // Set interval to check every minute if one hour has passed
    const checkStorageInterval = setInterval(() => {
      const lastCleared = localStorage.getItem('lastCleared');
      const oneHour = 60 * 60 * 1000; // One hour in milliseconds

      if (lastCleared) {
        const timeElapsed = Date.now() - parseInt(lastCleared, 10);
        if (timeElapsed > oneHour) {
          localStorage.clear(); 
          localStorage.setItem('lastCleared', Date.now().toString());
          console.log('Local storage cleared after one hour');
        }
      } else { 
      }
    }, 60 * 1000); // Check every 1 minute

    return () => clearInterval(checkStorageInterval); // Clear interval on unmount
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path='/'
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path='/feedbacks'
            element={
              <ProtectedRoute>
                <Feedbacks />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path='/details/:id'
            element={
              <ProtectedRoute>
                <Details />
              </ProtectedRoute>
            }
          /> */}
          <Route path='/login' element={<Login />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
